import { useXAxes, useXAxis, useYAxes } from '@mui/x-charts/hooks'
import React, { useEffect, useId, useState } from 'react'
import { EnrichedIssueEntity } from 'types/IssueEntity'
import IssueApi from '../../../../api/IssueApi'
import { useTheme } from '@mui/material/styles'
import { useAreaPlotData } from '@mui/x-charts/internals'

const issueApi = new IssueApi()

export const IssueSubscriptionPeriod = ({ issueId, onClick }: { issueId: string; onClick: () => void }) => {
    const xAxis = useXAxis()
    const xScale = xAxis.scale
    const [issue, setIssue] = useState<EnrichedIssueEntity | null>(null)
    const theme = useTheme()
    const { xAxis: xAxes } = useXAxes()
    const { yAxis: yAxes } = useYAxes()
    const clipPathId = useId()

    const [{ d } = {}] = useAreaPlotData(xAxes, yAxes) || []

    useEffect(() => {
        if (!issueId) return
        issueApi
            .findByIssueId(issueId)
            .then((issue) => {
                setIssue(issue)
            })
            .catch((e) => {
                console.error(e)
            })
    }, [issueId])

    if (issue?.type !== 'Rights issue' || !issue?.subStartDate || !issue?.subEndDate || !xAxis.data) return null

    const lastXAxisDate = xAxis.data[xAxis.data.length - 1]
    const startPosition = xScale(new Date(issue.subStartDate))
    const endPosition = xScale(
        new Date(issue.subEndDate).getTime() > lastXAxisDate ? new Date(lastXAxisDate) : new Date(issue.subEndDate),
    )

    if (!endPosition || !startPosition) return null

    return (
        <>
            <clipPath id={clipPathId}>
                <path d={d} />
            </clipPath>
            <rect
                clipPath={`url(#${clipPathId})`}
                onClick={() => onClick()}
                fill={theme.palette.FE.main}
                opacity={0.4}
                style={{ cursor: 'pointer' }}
                x={startPosition}
                width={endPosition - startPosition}
                height={'100%'}
                y='0'
            />
        </>
    )
}
